/**
 * 指定された桁数の最大値を計算します
 * @param length 桁数
 * @returns 最大値（例：length=2の場合、99）
 */
export const getCodeMaxValue = (length: number): number => {
  if (typeof length !== 'number' || length <= 0) {
    throw new Error('Invalid length parameter');
  }
  return 10 ** length - 1;
};
